import { Link } from 'react-router-dom';
import { useCmsNavPages } from '@/hooks/useCms';

export function Footer() {
  const { data: navPages = [] } = useCmsNavPages();

  return (
    <footer className="border-t border-border bg-background/60 backdrop-blur-md">
      <div className="container mx-auto px-4 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-sm text-muted-foreground font-mono">
          © ZeroDelta. All rights reserved.
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {navPages.map((page) => (
            <Link
              key={page.slug}
              to={`/p/${page.slug}`}
              className="text-sm font-mono text-muted-foreground hover:text-foreground transition-colors"
            >
              {page.title}
            </Link>
          ))}
          <Link
            to="/authors"
            className="text-sm font-mono text-muted-foreground hover:text-foreground transition-colors"
          >
            Credits
          </Link>
        </div>
      </div>
    </footer>
  );
}